import parsePhoneNumberFromString from "libphonenumber-js/min";

export function isPhoneValid(phone: string) {
  const [prefix, localNumber] = phone.split(".");
  const fullNumber = `${prefix}${localNumber}`;
  const parsed = parsePhoneNumberFromString(fullNumber);
  return parsed?.isValid() ?? false;
}
